"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var QueriesStore_1 = require("stores/QueriesStore");
var stage_3_0_png_1 = __importDefault(require("res/img/stage-3-0.png"));
var stage_3_1_png_1 = __importDefault(require("res/img/stage-3-1.png"));
var stage_3_2_png_1 = __importDefault(require("res/img/stage-3-2.png"));
var stage_3_3_png_1 = __importDefault(require("res/img/stage-3-3.png"));
var stage_3_4_png_1 = __importDefault(require("res/img/stage-3-4.png"));
var PODStage3Graphic = function (_a) {
    var currentStage3 = _a.currentStage3;
    return (react_1.default.createElement("div", { className: "pod-ipc-graphic" },
        react_1.default.createElement("img", { src: currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_2 ? stage_3_4_png_1.default :
                currentStage3 === QueriesStore_1.PODStage3Parts.CUSTOMER_SERVICES ? stage_3_3_png_1.default :
                    currentStage3 === QueriesStore_1.PODStage3Parts.CREDIT ? stage_3_2_png_1.default :
                        currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1 ? stage_3_1_png_1.default :
                            stage_3_0_png_1.default, alt: "Stage 3 Graphic" })));
};
exports.default = PODStage3Graphic;
